import { makeAutoObservable, runInAction } from "mobx";
import { debounce } from "lodash";

import { SuggestedCompany } from "../types/CompanyInfo";
import { ApiService } from "../api";
import { isBlank } from "../utils/strings";

import { RadioFieldModel } from "../common/commonForms";

export const DEBOUNCE_MS = 300;

export default class SearchController {
  suggestedCompanies: SuggestedCompany[] = [];
  isLoading = false;
  searchCountrySelection: RadioFieldModel<CompanySearchCountry>;
  apiService: ApiService;

  constructor(apiService: ApiService) {
    this.apiService = apiService;
    this.searchCountrySelection = new RadioFieldModel({
      value: CompanySearchCountry.norway,
      options: [CompanySearchCountry.norway, CompanySearchCountry.sweden],
      idFn: (option) => option,
      labelFn: (option) => ({ key: option }),
    });
    makeAutoObservable(this, {}, { autoBind: true });
  }

  clearSuggestedCompanies() {
    this.suggestedCompanies = [];
  }

  debouncedCompanySearch = debounce(async (value: string) => {
    if (isBlank(value)) {
      runInAction(() => this.clearSuggestedCompanies());
      return;
    }

    try {
      runInAction(() => {
        this.isLoading = true;
      });
      const companies = await this.apiService.getCompanies(value);
      runInAction(() => (this.suggestedCompanies = companies));
    } catch (e) {
      runInAction(() => this.clearSuggestedCompanies());
    } finally {
      runInAction(() => {
        this.isLoading = false;
      });
    }
  }, DEBOUNCE_MS);
}

export enum CompanySearchCountry {
  norway = "norway",
  sweden = "sweden",
}
